import {
    DataServiceQuery,
    IQueryResultSettings,
    IDataServiceRequest,
    IContext,
    AsyncResult,
    callActionOrExecute
} from '@msdyn365-commerce/retail-proxy';
import { IKartverketAddress, KartverketAddressExtensionClass } from './entities/kartverket-address';

function searchAddressQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function searchAddressInput(queryResultSettings: IQueryResultSettings, searchTerm: string): IDataServiceRequest {
    const query = searchAddressQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchAddress',
        false,
        KartverketAddressExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'IKartverketAddress' },
        {
            searchTerm: searchTerm
        }
    );
}

export function searchAddressAsync(context: IContext, searchTerm: string): AsyncResult<IKartverketAddress[]> {
    const request = searchAddressInput(context.queryResultSettings || {}, searchTerm);
    return callActionOrExecute<IKartverketAddress[]>(request, context.callerContext);
}
